import { Space, Tag, Typography } from 'antd';
import { BookingEvent } from '../../types/booking';

const { Text, Paragraph } = Typography;

const BookingEventCard = ({ eventData }: { eventData: BookingEvent }) => {
    const event = new BookingEvent(eventData);
    const {
        isAdmin,
        isEmulated,
        isBusiness,
        originRestart,
        type,
        orders,
    } = event;

    const hasTip = (): boolean => !!orders && orders.length > 0 && orders[0]?.tip;

    return (

        <Space direction="vertical">
            <Text>
                {event.description}
            </Text>
            {
                event?.errorMessage && (
                    <Text strong style={{ fontSize: '12px', fontStyle: 'italic' }}>
                        {event?.errorMessage}
                    </Text>
                )
            }
            {
                event.registeredByText ? (
                    <Space size={0} direction="vertical">
                        <Space size={8}>
                            <Text strong>
                                {'Registered by: ' }
                            </Text>
                            <Text>
                                {event.registeredByText || ''}
                            </Text>
                        </Space>
                        <Text strong style={{ fontSize: '12px', fontStyle: 'italic' }}>
                            {event.registeredBy?.email || ''}
                        </Text>
                    </Space>
                ) : event.registeredBy ? (
                    <Space size={0} direction="vertical">
                        <Text>
                            <strong>Registered by: </strong>
                            {' '}
                            {event.registeredBy?.name || ''}
                        </Text>
                        <Text strong style={{ fontSize: '12px', fontStyle: 'italic' }}>
                            {event.registeredBy?.email || ''}
                        </Text>
                    </Space>
                ) : null
            }
            {
                hasTip() && (
                    <Paragraph strong style={{ fontSize: '12px', fontStyle: 'italic' }}>
                        <Space size={4}>
                            Restart with tip:
                            {orders?.[0]?.tip || 0}
                        </Space>
                    </Paragraph>
                )
            }
            <Space size={4}>
                {
                    isEmulated && (
                        <Tag color="yellow">
                            Emulated
                        </Tag>
                    )
                }
                {
                    (originRestart === 'ADMIN' || isAdmin) && (type !== 'STATUS_UPDATE') && (
                        <Tag color="green">
                            By Admin
                        </Tag>
                    )
                }
                {
                    (originRestart === 'BUSINESS' || isBusiness) && (
                        <Tag color="blue">
                            By Business
                        </Tag>
                    )
                }
                {
                    (originRestart === 'PICKER_AI') && (
                        <Tag color="purple">
                            By Picker AI
                        </Tag>
                    )
                }
            </Space>
        </Space>
    );
};

export default BookingEventCard;
